<template>
  <div>
    <b-row>
      <b-col>
        <b-form @submit.prevent="salvar">
          <b-form-group id="input-group-username" label="Nome de Login:" label-for="input-username">
            <b-form-input
              id="input-username"
              v-model="customer.username"
              required
              placeholder="Digite o login"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-fullName" label="Nome Completo:" label-for="input-fullName">
            <b-form-input
              id="input-fullName"
              v-model="fullName"
              required
              placeholder="Digite o Nome Completo"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-extraInfo"
            label="Informações Adicionais:"
            label-for="input-extraInfo"
          >
            <b-form-input
              id="input-extraInfo"
              v-model="extraInfo"
              placeholder="Gerência, Local, Finalidade, etc"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-email" label="Email:" label-for="input-email">
            <b-form-input
              id="input-email"
              v-model="email"
              type="email"
              required
              placeholder="Digite o email"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-password" label="Senha:" label-for="input-password">
            <b-form-input
              id="input-password"
              v-model="password"
              type="password"
              placeholder="Opcional, caso vazio a senha não será alterada"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-profile-id" label="Perfil de Acesso:" label-for="input-profile-id">
            <b-form-select id="input-profile-id" v-model="profileId" :options="getProfiles" required></b-form-select>
          </b-form-group>

          <b-alert
            v-model="successState"
            variant="success"
            dismissible
          >Usuário alterado com sucesso!</b-alert>
          <b-alert
            v-model="errorState"
            variant="danger"
            dismissible
          >Não foi possível alterar o usuário</b-alert>
          <b-button type="submit" variant="primary" class="mr-2 mb-2">
            <b-spinner v-if="loading" small class="mr-2"></b-spinner>Salvar
          </b-button>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Account",
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      username: this.customer.username,
      fullName: this.customer.fullName,
      extraInfo: this.customer.extraInfo,
      email: this.customer.email,
      profileId: this.customer.profileId,
      password: "",
      editing: false,
      loading: false,
      errorState: false,
      successState: false,
    };
  },
  computed: {
    getProfiles() {
      var profiles = [];
      this.$store.getters.getProfiles.forEach(profile => profiles.push({value: profile.id, text: profile.name}));
      return profiles;
    }
  },
  methods: {
    salvar() {
      this.errorState = false;
      this.successState = false;
      this.loading = true;
      this.$store
        .dispatch("patchUserById", {
          id: this.customer.id,
          username: this.username,
          fullName: this.fullName,
          extraInfo: this.extraInfo,
          email: this.email,
          password: this.password,
          profileId: this.profileId,
        })
        .then(() => {
          this.loading = false;
          this.errorState = false;
          this.successState = true;
        })
        .catch(error => {
          this.successState = false;
          this.loading = false;
          this.errorState = true;
          console.log(error);
        });
    }
  }
};
</script>

<style>
</style>